import {defineStore} from 'pinia'
import axios from '@/api/axios'

const labelByRequestType = {
  'BM Accounts Migration': 'Facebook BM Transfer',
  'FB Page Access Share': 'Facebook Page Access',
}

export const useOtherRequestStore = defineStore({
  id: 'OtherRequest',
  state: () => ({
    types: ['BM Accounts Migration', 'Ad Tracking', 'FB Page Access Share', 'Google Business Verification', 'Other'],
  }),
  getters: {
    typeOptions: state => {
      const valueByRequestType = {
        'Google Business Verification': 'Advertiser Verification',
      }

      return state.types.map(item => ({
        value: valueByRequestType[item] || item,
        label: labelByRequestType[item] || item,
      }))
    },
    typeAllOptions: state => {
      const types = cloneSafe(state.types)

      const otherIndex = types.findIndex(type => type === 'Other')
      if (otherIndex !== -1) {
        types.splice(otherIndex, 0, 'Ad Account Disabled')
      }

      const valueByRequestType = {
        'Google Business Verification': 'Advertiser Verification',
      }

      return types.map(item => ({
        value: valueByRequestType[item] || item,
        label: labelByRequestType[item] || item,
      }))
    },
  },
  actions: {
    async getOtherRequests(filters = {}) {
      const {data} = await axios.get('other-requests', {
        params: filters,
      })

      return data
    },
    async createOtherRequest(payload) {
      const {data} = await axios.post('other-requests', payload)

      return data
    },
    async getOtherRequest(hash, filters = {}) {
      const {data} = await axios.get(`other-requests/${hash}`, {
        params: filters,
      })

      return data
    },
    async updateOtherRequest(hash, payload, filters = {}) {
      const {data} = await axios.patch(`other-requests/${hash}`, payload, {
        params: filters,
      })

      return data
    },
    async updateOtherRequestStatus(hash, payload, filters = {}) {
      const {data} = await axios.patch(`other-requests/${hash}/status`, payload, {
        params: filters,
      })

      return data
    },
  },
})
